<template>
    <div>
        
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>       
        <Loader v-if="loading" />
        <div v-else-if="data.chapter.id">

            <PageTitle v-bind:title="title" v-bind:admin="false" />

            <div class="row  mt-4">
                <div class="col-md-6">
                    <h3>Введение:</h3>
                    <div class="mt-3 bg-light p-2 bg-white rounded" v-html="brFunc(data.chapter.description)"></div>                   
                </div>
                <div class="col-md-6 text-right" >
                    <div class=" p-4 text-right">
                        <p v-if="data.status_id != 0" style="color:gray">
                            Статус: 
                            <span v-if="data.status_id == 1" class="badge badge-info">в работе</span>
                            <span v-if="data.status_id == 5" class="badge badge-success">завершено</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>

            <template v-if="data.status_id == 5">
                <!-- "глава пройдена! можете откатить результаты": -->
                <Winner v-bind:message="tip_messages[0]" v-bind:type="0" />
                <button type="button" class="btn btn-block btn-primary mt-3" @click.prevent="unfinishChapter">"Откатить" результаты</button>
            </template>
            <template v-if="(!data.questions.length) && (data.canBeFinished)">
                <!-- "изучите материал, и нажмите 'завершить'": -->
                <Tip v-bind:message="tip_messages[1]" />
            </template>
            <template v-if="(data.questions.length) && (data.canBeFinished)">
                <!-- "вы прошли тестирование, теперь нажмите 'завершить главу'": -->
                <!-- <Winner v-bind:message="tip_messages[3]" v-bind:type="0" /> -->
                <ChapterMarkAndFinish v-if="data.canBeFinished" v-on:need-to-reload="loadData()" v-bind:chapter="data.chapter" v-bind:caption="'Тестирование завершено!'" />
            </template>
            <template v-if="(data.questions.length) && (!data.canBeFinished) && (data.status_id == 1)">
                <!-- "изучите материал, и переходите к тестированию": -->
                <Tip v-bind:message="tip_messages[2]" />
            </template>
           

            <div class="row p-2 mt-3">
                <div class="col">
                    <h3>Материал к изучению:</h3>
                    <div class="mt-3 bg-light p-2 bg-white rounded" v-html="data.chapter.text"></div>
                </div>
            </div>




            <!-- Если у главы нет тестирования: -->
            <template v-if="(data.status_id != 5) && (!data.questions.length) && (data.canBeFinished)">
                <ChapterMarkAndFinish v-if="data.canBeFinished" v-on:need-to-reload="loadData()" v-bind:chapter="data.chapter" v-bind:caption="'К этой главе нет тестирования.'" />
                <!-- <button type="button" class="btn btn-block btn-primary" @click.prevent="finishChapter">Завершить Главу</button> -->
            </template>

            <!-- Если есть тестирование, нам в любом случае нужно иметь возможность перейти к нему: -->
            <template v-if="data.questions.length">
                <router-link v-if="data.status_id == 5" class="btn btn-block btn-secondary" :to="{ name: 'questions', params: { id: data.chapter.id } }">Просмотреть результаты тестирования</router-link>
                <router-link v-else-if="data.canBeFinished" class="btn btn-block btn-secondary" :to="{ name: 'questions', params: { id: data.chapter.id } }">Просмотреть результаты тестирования</router-link>
                
                <div v-else-if="!data.canBeFinished" class="row">
                    <div class="col col-2"></div>
                    <div class="col card mt-3 col-8">
                        <div class="card-header">
                            <img src="/icons/marker.png" width="32px" alt="">
                            <!-- Курс пройден на {{ Math.round(100 * c.chapters_finished_count / c.chapters_count) }}% -->
                            <!-- Тестирование к главе -->
                        </div>
                        <div class="card-body">
                            <h5 class="card-title">Тестирование к главе</h5>
                            <p class="card-text">
                                <ul>
                                    <li class="li_test">Вопросов в тестировании: {{ data.questions.length }}</li>
                                    <!--
                                    <li>Пройдено глав: {{ c.chapters_finished_count }}</li>
                                    <li v-if="c.next_chapter">
                                        Следующая глава:
                                        <router-link :to="{ name: 'chapter_show', params: { id: c.next_chapter.id } }">{{ c.next_chapter.name }}</router-link>
                                    </li>
                                    -->
                                </ul>                    
                            </p>
                            <!-- <router-link class="btn btn-primary" :to="{ name: 'course_show', params: { id: c.id } }">Перейти к курсу</router-link> -->
                        </div>
                        <div class="card-footer text-muted">
                            <router-link class="btn  btn-primary" :to="{ name: 'questions', params: { id: data.chapter.id } }">Перейти к тестированию</router-link>
                            <!--
                            <template v-if="c.last_activity">
                                Последняя активность:
                                {{ localeDate(c.last_activity) }}
                            </template>
                            -->
                        </div>
                    </div>
                    <div class="col-2 col"></div>
                </div>
                
                <!-- <router-link v-else-if="!data.canBeFinished" class="btn btn-block btn-primary" :to="{ name: 'questions', params: { id: data.chapter.id } }">Перейти к тестированию</router-link> -->
            </template>          

            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>



<!--
            <div>
                <br/><br/><br/><br/><br/><br/>
                <h3>-= ДЛЯ ОТЛАДКИ =-</h3>
                <h1>Chapter SHOW</h1>
                <p>chapter.id: {{data.chapter.id}}</p>
                <p style="color:red">canBeFinished: {{data.canBeFinished}}</p>
                <button type="button" class="btn btn-primary" @click.prevent="finishChapter">Завершить Главу</button>
                <button type="button" class="btn btn-primary" @click.prevent="unfinishChapter">"Открыть" Главу</button>
                <button type="button" class="btn btn-primary" @click.prevent="finishChapterFORCED">Завершить Главу FORCED</button>
                <router-link class="btn btn-primary" :to="{ name: 'questions', params: { id: data.chapter.id } }">Перейти к тестированию</router-link>
            </div>
-->
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
import Tip from '@/components/Tip'
import Winner from '@/components/Winner'
import ChapterMarkAndFinish from '@/components/ChapterMarkAndFinish'
//import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', any: '' },
            title: '',
            bcrumbs: [],
            tip_messages: [
                'Глава пройдена! Если хотите, Вы можете откатить все результаты и пройти главу заново.',
                'Внимательно изучите теоретический материал, а затем нажмите "Завершить Главу".',
                'Внимательно изучите теоретический материал, а затем переходите к тестированию.',
                'Поздравляем! Вы прошли тестирование! Теперь нажмите "Завершить Главу"!',
            ]
        }
    },
   async mounted() {
       this.loadData()
    },
    methods: {
        //
        // Переносы из textarea конвертим в переносы для абзаца.
        //
        brFunc(str) {
            if (str) {
                return str.replace(/\n/g, "<br />")
            }
        },
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('chapters/'+this.$route.params.id)
                this.data = response.data
                this.title = this.data.chapter.name
                this.bcrumbs = response.data.bcrumbs

// this.data.questions = []
//this.data.status_id = 5
// this.data.canBeFinished = false
              
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.load = e.response.data.error
                }
                else if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },

        /*
            Эта ф-ция переехала в ChapterMarkAndFinish.
            Тут по идее не нужна.
        async finishChapter() {
            this.errors.any = ''
            try {
                let response = await axios.post('chapters/'+this.$route.params.id+'/finish')
                if (response.status == 200) {
                    this.loading = true
                    this.loadData()
                }
            }
            catch(e) {         
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Неизвестная ошибка при завершении Главы."
                }
            }
        },
        */

        async finishChapterFORCED() {
            this.errors.any = ''
            try {
                let response = await axios.post('chapters/'+this.$route.params.id+'/finishFORCED')
                if (response.status == 200) {
                    this.loading = true
                    this.loadData()
                }
            }
            catch(e) {         
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Неизвестная ошибка при завершении Главы."
                }
            }
        },


        async unfinishChapter() {
            this.errors.any = ''
            try {
                let response = await axios.post('chapters/'+this.$route.params.id+'/unfinish')
                if (response.status == 200) {
                    this.loading = true
                    this.loadData()
                }
            }
            catch(e) {         
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Неизвестная ошибка при 'открытии' Главы."
                }
            }
        },

    },
    components: {
        Loader,
        BreadCrumbs,
        PageTitle,
        Tip,
        Winner,
        ChapterMarkAndFinish,
    }
}
</script>


<style scoped>
.li_test {
    /* border: 2px solid red; */
    list-style: none; 
    background: url(/icons/arrow.png) no-repeat left 50%; 
    padding-left: 25px;
}
</style>